<template>
	<div class="contact-content wrapper">
		<transition name="fadeIn" mode="out-in">
			<div :class="['contact-content__container', getRouteLeave ? 'contact-content__container--leave' : '']" v-if="contentData" :key="dataReady">
				
				<div class="contact-content__text" :style="{ minHeight: !getMobile && getViewport ? `${getViewport.height - 200 - 182}px` : '0' }" v-html="contentData.body[0].content.rendered"></div>

				<footer-comp></footer-comp>
			</div>

			<div v-else class="loading-page" :key="dataReady">
				<loader :label="routeName"></loader>
			</div>
		</transition>
<!-- 		<div>
			<div>			
				<p class="contact-content__intro">Please, contact me !</p>

				<div class="form">
					<div class="input-container">
						<input-comp :herited-data="{ type: 'email', name:'email', label: 'Your mail' }"></input-comp>
					</div>

					<div class="input-container">
						<input-comp :herited-data="{ type: 'textarea', name:'content', label: 'Your message' }"></input-comp>
					</div>
					
					<div class="input-submit">
						<input type="submit" value="Send your message" @click="submitForm">
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import { common } from '~components/common'
	import { ui } from '~components/ui'
	import PageTitleMixin from '~mixins/PageTitle'
	import store from '~store'

	export default {
		name: 'contact',
		components: {
			common,
			ui
		},
		mixins: [PageTitleMixin],
		beforeRouteEnter (to, from, next) {
			store.commit('setRouteLeave', false)
			next()
		},
		beforeRouteLeave (to, from, next) {
			store.commit('setRouteLeave', true)

			setTimeout(() => {
				next()
			}, 1000)
		},
		created () {
			this.fetchData()
		},
		data () {
			return {
				contentData: null,
				routeName: this.$route.name,
				dataReady: false,
				minHeight: this.$store.getters.getViewport.height
			}
		},
		mounted () {
			this.$store.commit('setPostCategory', null)
		},
		methods: {
			fetchData () {
				this.dispatchPageTitle('Contact')
				this.$store.commit('setPostCategory', null)

				if (!this.$store.getters.getContactData) {
					this.get('contact', 'setContactData', null).then((res) => {
						this.contentData = res
						this.dataReady = 1
					})
				} else {
					const self = this

					setTimeout(() => {
						self.contentData = self.$store.getters.getContactData
						self.dataReady = 1
					}, 500)
				}
			},
			submitForm () {
				this.$http.post('wp/v2/contact-api', {
					full_name: 'Anonyme',
					email: this.getFormData.email,
					phone: '0606060606',
					city: 'Anonyme',
					content: this.getFormData.content,
					token: 'e424cc23b4f93230eb84148598ec659d'
				}).then((res) => {
					console.log(res)
				})
			}
		},
		watch: {
			getViewport (val) {
				this.minHeight = val.height
			}
		},
		computed: {
			getFormData () {
				return this.$store.getters.getFormData
			},
			getMobile () {
				return this.$store.getters.getMobile
			},
			getViewport () {
				return this.$store.getters.getViewport
			},
			getRouteLeave () {
				return this.$store.getters.getRouteLeave
			}
		}
	}
</script>

<style lang="scss">
/* .contact-content {
		position: relative;
		z-index: 5;
		height: calc(100vh - 50px);

		 > div {
			position: relative;
			top: -109px;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;

			> div {
				width: 100%;
			}
		}
	} */
	.contact-content {
		p {
			@include fontSize(15);
		}

		a {
			@include transition(all .4s);

			&:hover {
				opacity: .5;
			}
		}
	}

	.contact-content__container {
		@include transition(all .4s);

		&.contact-content__container--leave {
			opacity: 0;
		}
	}

	.contact-content__text {
		max-width: 700px;
		margin: auto;
	}

	.input-container {
		margin-top: 30px;
	}

	.contact-content__intro {
		margin: 0 0 50px;
		letter-spacing: 0.05em;
		text-align: center;
		@include fontSize(25);

		+ .input-container {
			margin-top: 0;
		}
	}

	.form {
		width: 90%;
		max-width: 600px;
		margin: auto;
	}

	.input-submit {
		position: relative;
		width: 215px;
		margin: 50px auto 0;

		input {
			display: block;
			padding: 0;
			border: 0;
			text-align: center;
			background: none;
			font-family: $main_font;
			cursor: pointer;
			letter-spacing: 0.05em;
			outline: none;
			@include fontSize(25);
		}

		&::after {
			position: absolute;
			right: 0;
			bottom: -5px;
			left: 0;
			width: 100%;
			height: 2px;
			background: $basic_black;
			opacity: 0;
			content: '';
			@include transition(all .4s);
		}

		&:hover {
			&::after {
				opacity: 1;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/content-type/Contact.vue?0542546e